import Reports from 'screens/Reports';
import ReportsIcon from 'assets/left_navbar_icons/reports.svg?react';
import { paths } from 'routes/paths';

const routes = [
  {
    id: 'reports',
    key: 'reports',
    label: 'Reports',
    path: paths.reports,
    exact: true,
    secure: true,
    disabled: false,
    component: Reports,
    icon: ReportsIcon,
    nav: 'leftNav'
  }
];

export default routes;
